const storageKey = (dispensarySlug: string) => `thedrop:cwa:deliveryPay:${dispensarySlug}`;

export type CheckoutDeliveryPaymentMethod = "ach" | "cash_at_delivery";

/** Default **cash at delivery** so step 2 does not push Plaid until the customer opts into ACH. */
export function readCheckoutDeliveryPaymentMethod(dispensarySlug: string): CheckoutDeliveryPaymentMethod {
  if (typeof sessionStorage === "undefined") return "cash_at_delivery";
  try {
    const raw = sessionStorage.getItem(storageKey(dispensarySlug));
    if (raw === "ach") return "ach";
    if (raw === "cash_at_delivery") return "cash_at_delivery";
  } catch {
    /* ignore */
  }
  return "cash_at_delivery";
}

export function writeCheckoutDeliveryPaymentMethod(
  dispensarySlug: string,
  method: CheckoutDeliveryPaymentMethod,
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(storageKey(dispensarySlug), method);
  } catch {
    /* ignore */
  }
}
